module.exports = __webpack_public_path__ + "img/business3.bb496759.png";